module.exports = __webpack_public_path__ + "img/icon3.4766e287.png";